import { get, post, omsMainServer } from '@/utils/http';
import api from '@/api';
import { message } from 'ant-design-vue';
import {
    setAccount,
    setUserEnv,
    setUserZnEnv,
    setToken,
    setUserSys,
    // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';
import { getUiFitment } from '@/utils/accessResources';
import * as dd from 'dingtalk-jsapi';
import { openAuth } from 'dingtalk-design-libs/biz/openAuth';

const { envList } = require('../../../config/dev.proxy');

class DingTalkApprovalClass {
    /**
     * 0=登录失败
     * 1=登录中
     * 2=前置成功，等待再次打开
     */
    options = 1;
    // 0: 加载中 1: 加载错误
    loadingStatus = 0;

    errorMessage = '';


    log = 'dingTalkLog:';

    args = {
        // workflowId: '2177569', // 流程id
        // taskId: '2177630', // 任务ID
        // act: 'todo', // 表示哪种数据，待办/已办/我发起的/抄送
        // appType: '1', // 终端类型 1pc 2h5
        // znAppId: '90001', // 登陆需要使用的appId
        // rf: '0', // pc端需要的参数，0表示不自动跳转，1表示自动跳转

        // domain: 'https://farm-xn-dev.znlh.work/',
        // path: 'process/detail?objectId=102&layoutApiKey=detail',
        // approval: '',
        // bizId: '1120378166500528128',
        // routeUrl: null,
        // routeParams: null,
    };

    // 飞书登录接口返回
    urlRes = {};

    // 用户权限查询信息接口返回
    urlLoginRes = {};

    constructor() {
        if (typeof DingTalkApprovalClass.instance === 'object') {
            return DingTalkApprovalClass.instance;
        }
        DingTalkApprovalClass.instance = this;
        this.init();
    }

    /**
     * 初始化
     * @return
     */
    // eslint-disable-next-line class-methods-use-this
    init() {
        this.args = this.getQueryStringSource();
    }

    // eslint-disable-next-line class-methods-use-this
    initenv() {
        this.log += 'init: ' + window.location.href + '\n';
        console.log('init: ' + window.location.href);
        if (window.location.hostname.toString().includes('127.0.0.1')) {
            setUserEnv('dev');
        }
        localStorage.setItem('webSource', 'dingtalk');
        let isProduct = true;
        envList.forEach((m) => {
            if (window.location.hostname.toString().includes(m)) {
                isProduct = false;
                this.log += 'setUserZnEnv: ' + m + '\n';
                console.log('setUserZnEnv: ' + m);
                setUserZnEnv(m);
            }
        });
        if (window.location.hostname.toString().includes('127.0.0.1')) {
            isProduct = false;
            this.log += 'setUserZnEnvLocal: dev' + '\n';
            console.log('setUserZnEnvLocal: dev');
            setUserZnEnv('dev');
        }
        // 如果默认没有匹配到有诳环境，则默认为生产环境
        if (isProduct) {
            this.log += 'setUserZnEnvLocal: product' + '\n';
            console.log('setUserZnEnvLocal: product');
            setUserZnEnv('product');
        }
        setUserSys(this.args.znAppId);
    }

    getCorpIdFromUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        let corpId = urlParams.get('corpid');
        return corpId;
    };

    getClientIdByUrl = () => {
        let clientId = 'suitew5l27wrtbkh5khre';
        let env = 'prd';
        if (window.location.hostname.toString().includes('127.0.0.1')) {
            env = 'dev';
        }
        if (window.location.hostname.toString().includes('dev') || env === 'dev') {
            // 开发环境对应 开工智合dev应用
            clientId = 'suitepayfdqv9k8vvogss';
        } else if (window.location.hostname.toString().includes('sit') || env === 'sit') {
            // 测试环境对应 开工智合sit应用
            clientId = 'suiteksn8mrylvknsx275';
        } else {
            // 生产环境对应 开工智合prd应用
            clientId = 'suitew5l27wrtbkh5khre';
        }
        return clientId;
    }

    async startAuthAndLogin() {
        this.initenv();
        // 获取个人授权码
        const res = await this.requestOpenAuthCode();
        console.log('requestOpenAuthCode: ', res.result.authCode);
        this.log += 'requestOpenAuthCode: ' + res.result.authCode + '\n';
        this.args.authCode = res.result.authCode;

        // 获取企业授权码
        const entRes = await this.requestEnterpriseAuthCode();
        console.log('requestEntAuthCode: ', entRes.code);
        this.log += 'requestEntAuthCode: ' + entRes.code + '\n';
        this.args.code = entRes.code;

        // this.args.authCode = 'fa36fe6a5a3f3cde92b8b70493029183';
        // this.args.code = 'b1ee6f7035b23803beb18ab47bb47b54';
        // 使用授权码发起登录到众能系统，保存token
        const loginRes = await this.dingtalkLogin();
        console.log('dingtalkLoginRes: ', JSON.stringify(loginRes));
        this.log += 'dingtalkLoginRes: ' + JSON.stringify(loginRes) + '\n';
        setToken(loginRes);
        this.getLoginAccount(loginRes);
    }

    // 请求钉钉授权码
    requestOpenAuthCode() {
        console.log('requestAuthCode');
        return new Promise((resolve, reject) => {
            // 从URL中获取corpId
            let corpIdFromUrl = this.getCorpIdFromUrl();
            if (!corpIdFromUrl) {
                console.log('未找到 corpid 参数');
                reject(new Error('未找到 corpid 参数'));
                return;
            }
            console.log('corpid=', corpIdFromUrl);
            this.log += 'corpid=: ' + corpIdFromUrl + '\n';

            const __this = this;
            const clientId = this.getClientIdByUrl();
            this.log += 'clientId=: ' + clientId + '\n';
            console.log('clientId=', clientId);
            dd.ready(function () {
                __this.log += 'ready \n';
                console.log('ready');
                openAuth({
                    corpId: corpIdFromUrl,
                    clientId: clientId,
                    rpcScope: 'Contact.User.Read',
                    fieldScope: 'Contact.User.mobile',//'Contact.User.mobile', // 特殊权限点 Code, 在应用访问场景为空
                    type: 0,// 0：申请委托（个人）授权 1：申请应用（组织）授权
                }).then((result) => {
                    __this.log += 'openAuth' + '\n';
                    console.log('dingtalk auth result', result);
                    __this.log += 'dingtalk auth result: ' + JSON.stringify(result) + '\n';
                    resolve(result);
                }).catch((err) => {
                    __this.log += 'openAuth钉钉授权失败' + '\n';
                    console.log('钉钉授权失败:', err);
                    __this.log += '钉钉授权失败: ' + JSON.stringify(err) + '\n';
                    reject(err);
                });
            });
        });
    }

    // 请求钉钉企业授权码
    requestEnterpriseAuthCode() {
        console.log('requestAuthCode');
        return new Promise((resolve, reject) => {
            // 从URL中获取corpId
            const urlParams = new URLSearchParams(window.location.search);
            let corpIdFromUrl = this.getCorpIdFromUrl();
            if (!corpIdFromUrl) {
                console.log('未找到 corpid 参数');
                reject(new Error('未找到 corpid 参数'));
                return;
            }
            console.log('corpid=', corpIdFromUrl);
            this.log += 'corpid=: ' + corpIdFromUrl + '\n';

            const __this = this;
            const clientId = this.getClientIdByUrl();
            this.log += 'clientId =: ' + clientId + '\n';
            console.log('clientId =', clientId);
            dd.ready(function () {
                __this.log += 'ready \n';
                setTimeout(function () {
                    dd.requestAuthCode({
                        corpId: corpIdFromUrl,
                        clientId: clientId,
                        onSuccess: (result) => {
                            __this.log += 'requestAuthCode' + '\n';
                            console.log('dingtalk auth result', result);
                            __this.log += 'dingtalk auth result: ' + JSON.stringify(result) + '\n';
                            resolve(result);
                        },
                        onFail: (err) => {
                            __this.log += 'requestAuthCode钉钉授权失败' + '\n';
                            console.error('钉钉授权失败:', err);
                            __this.log += '钉钉授权失败: ' + JSON.stringify(err) + '\n';
                            reject(err);
                        },
                    });
                }, 1000);
            });
        });
    }

    /**
     * 解析url 返回参数
     * @return args
     *
     */
    // eslint-disable-next-line class-methods-use-this
    getQueryStringSource(url) {
        // eslint-disable-next-line no-restricted-globals
        let qs = '';
        if (!url) {
            qs = window.location.search.length > 0 ? window.location.search.substring(1) : '';
        } else {
            qs = url;
        }
        // eslint-disable-next-line prefer-const
        let args = {};
        // eslint-disable-next-line prefer-const
        let items = qs.length ? qs.split('&') : [];
        let item = null;
        let name = null;
        let value = null;
        let i = 0;
        const len = items.length;
        // eslint-disable-next-line no-plusplus
        for (i = 0; i < len; i++) {
            item = items[i].split('=');
            name = decodeURIComponent(item[0]);
            value = decodeURIComponent(item[1]);
            if (name.length) {
                args[name] = value;
            }
        }
        return args;
    }

    routerParam() {
        this.log += 'routerParam: ' + JSON.stringify(this.args) + '\n';
        console.log('routerParam: ', JSON.stringify(this.args));
        localStorage.setItem('dingtalkLoginLog', this.log);
        if (this.args.routeUrl) {
            this.log += 'routeUrl: ' + this.args.routeUrl + '\n';
            console.log('routeUrl: ', this.args.routeUrl);
            localStorage.setItem('dingtalkLoginLog', this.log);
            // 如果有重定向参数，则直接跳转
            window.location.href = this.args.routeUrl;
        } else if (this.args.workflowId) {
            this.log += 'workflowId: ' + this.args.workflowId + '\n';
            console.log('workflowId: ', this.args.workflowId);
            localStorage.setItem('dingtalkLoginLog', this.log);
            // 如果有流程id，则查询流程参数
            const params = {
                workflowId: this.args.workflowId,
                taskId: this.args.taskId,
                act: this.args.act,
                znAppId: this.args.znAppId,
            };
            const _this = this;
            get(api.routerParam, params).then((res) => {
                _this.args = { ...this.args, ...res };
                _this.options = 2;
                _this.toProcessPage();
            }).catch(() => {
                _this.options = 0;
            });
        } else {
            this.log += 'no redirect params' + '\n';
            console.log('no redirect params' + '\n');
            localStorage.setItem('dingtalkLoginLog', this.log);
            // 如果没有重定向参数，则直接跳转到/
            window.location.href = '/';
        }

        
    }

    // 钉钉登录-获取权限流程，待联调
    dingtalkLogin() {
        this.options = 1;
        console.log('dingtalkLoginAuthCode:', this.args.authCode);
        this.log += 'dingtalkLoginAuthCode:' + this.args.authCode + '\n';
        console.log('dingtalkLoginCode:', this.args.code);
        this.log += 'dingtalkLoginCode:' + this.args.code + '\r\n';
        // 从URL中获取corpId
        let corpIdFromUrl = this.getCorpIdFromUrl();
        return new Promise((resolve, reject) => {

            omsMainServer({
                method: 'post',
                url: api.dingtalkLogin,
                data: {
                    corpId: corpIdFromUrl || '',
                    authCode: this.args.authCode || '',
                    code: this.args.code || '',
                    appId: this.args.znAppId || '',
                }
            }).then((response) => {
                if (response && +response.status === 200) {
                    this.log += 'requestURL:' + response.request.responseURL + '\n';
                    this.log += 'tid:' + response.headers['x-hubble-trace-id'] + '\n';
                    const { errCode, data, message: resMessage = '' } = response.data;
                    if (errCode) {
                        if (errCode === 'A030030') {
                            message.error('token过期，请重新登录');
                            window.location.href = '/login';
                            reject();
                        } else if (errCode === 'A010721') {
                            message.error('该用户已禁用');
                            setTimeout(() => {
                                window.location.href = '/login';
                            }, 1000);
                        } else if (errCode === '0') {
                            resolve(data);
                        } else {
                            if (resMessage) {
                                this.loadingStatus = 1;
                                this.errorMessage = resMessage;
                                // message.error(resMessage);
                            }
                            reject();
                        }
                    } else {
                        message.error('哎呀，系统异常，请联系管理员！');
                        reject();
                    }
                } else {
                    message.error('哎呀，系统异常，请联系管理员！');
                    reject();
                }

            }).catch((err) => {
                console.log('dingtalkLoginFailed:', JSON.stringify(err));
                this.log += 'dingtalkLoginFailed:' + JSON.stringify(err) + '\n';
                this.options = 0;
                reject(err);
            });



            // post(api.dingtalkLogin, {
            //     corpId: corpIdFromUrl || '',
            //     authCode: this.args.authCode || '',
            //     code: this.args.code || '',
            //     appId: this.args.znAppId || '',
            // }).then((res) => {
            //     console.log('dingtalkLoginSuccess:', JSON.stringify(res));
            //     this.log += 'dingtalkLoginSuccess:' + JSON.stringify(res) + '\n';
            //     resolve(res);
            // }).catch((err) => {
            //     console.log('dingtalkLoginFailed:', JSON.stringify(err));
            //     this.log += 'dingtalkLoginFailed:' + JSON.stringify(err) + '\n';
            //     this.options = 0;
            //     reject(err);
            // });
        });
    }

    getLoginAccount(loginRes) {
        return post(api.loginAccount, {})
            .then((res) => {
                // let res = {"id":"1555862946591457384","account":"1555862946591457384","accountId":"1555862946591457384","passportId":"1000200000002289048","passportName":"韩成刚","passportAccount":"oH49J5LMpspPHKtkN-K23OoEOC-g","aliasName":"韩成刚","name":"韩成刚","appId":"10009","appPlatform":"10009","appStatus":true,"tenantId":"MER20220411007206","tenantCode":"MER20220411007206","tenantName":"北京妙树托育服务有限公司","phone":"18626459670","domainAccount":"","jobNumber":"","jobPostCode":"ADMIN","jobPost":"管理员","accountState":1,"employeeStatus":"3","orgId":"15933","orgCode":"MER_000001","company":"1000200000001135209","customerId":"1000200000001135209","customerName":"北京妙树托育服务有限公司","customerType":1,"createdAt":"2022-08-11T20:07:55.000+08:00","createdBy":"-1","pwdStatus":1};
                this.urlRes = loginRes;
                this.urlLoginRes = res;
                console.log('getLoginAccount', res);
                this.log += 'getLoginAccount:' + JSON.stringify(res) + '\n';
                // 之后缓存菜单需要参数
                setAccount(res, loginRes);
                return getUiFitment().then(() => {
                    console.log('getUiFitment:', res.id);
                    this.log += 'getUiFitment222:' + res.id + '\n';
                    if (res.id) {
                        this.routerParam();
                        return res;
                    } else {
                        this.options = 0;
                        throw new Error('用户ID不存在');
                    }
                });
            })
            .catch((err) => {
                message.error('用户信息查询失败');
                this.options = 0;
                throw err;
            });
    }
}

export default DingTalkApprovalClass;
